module.exports = __webpack_public_path__ + "media/images/front/icon_recommend_01-5160177ce53c760e427cd683061624e2.svg";